import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../components/UI/Layouts";
import Content from "../../components/UI/Layouts/Content";
import { Streaming as StreamingType } from "../../types";
import PageHeader from "../../components/common/PageHeader";
import { useTranslation } from "react-i18next";
import { useStores } from "../../hooks/useStores";
import { Breadcrumb, BreadcrumbItem } from "../../components/UI/Breadcrumb";
import { useSnackbar } from "notistack";
import { observer } from "mobx-react";
import Loading from "../../components/common/Loading";
import StreamingForm from "../../components/ScreenStreaming/StreamingForm";

const Streaming: React.FC = observer(() => {
  const { configStore } = useStores();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchStreaming = useCallback(async () => {
    await configStore.fetchStreaming().catch((err) => {
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    });
  }, [enqueueSnackbar, configStore]);

  const handleSubmit = useCallback(
    async (data: StreamingType) => {
      setIsSubmitting(true);
      try {
        if (data.id) {
          await configStore.updateStreaming(data);
        } else {
          await configStore.addStreaming(data);
        }
        enqueueSnackbar(t("common.actionExecutedSuccessfully"), {
          variant: "success",
        });
      } catch (error: any) {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      } finally {
        setIsSubmitting(false);
      }
    },
    [enqueueSnackbar, configStore, t]
  );

  useEffect(() => {
    fetchStreaming();
  }, [fetchStreaming]);

  return (
    <Layout hideFooter>
      <Content borderBottomWidth="1px" align="top">
        <Breadcrumb my={"20px"}>
          <BreadcrumbItem path="/">
            {t("screens.streaming.breadcrumb.home")}
          </BreadcrumbItem>
          <BreadcrumbItem active>
            {t("screens.streaming.breadcrumb.streaming")}
          </BreadcrumbItem>
        </Breadcrumb>

        <PageHeader
          title={t("screens.streaming.pageHeader.title")}
          buttonEnable={false}
        />
      </Content>
      {configStore.isLoading ? (
        <Loading />
      ) : (
        <StreamingForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => handleSubmit(data)}
          streaming={configStore.streaming}
        />
      )}
    </Layout>
  );
});

export default Streaming;
